export const USER_REQUEST_LOCATION_IS_FETCHING_GEOLOCATION = 'USER_REQUEST_LOCATION_IS_FETCHING_GEOLOCATION';
export const USER_REQUEST_LOCATION_FETCH_GEOLOCATION_SUCCESS = 'USER_REQUEST_LOCATION_FETCH_GEOLOCATION_SUCCESS';
export const USER_REQUEST_LOCATION_FETCH_GEOLOCATION_FAILURE = 'USER_REQUEST_LOCATION_FETCH_GEOLOCATION_FAILURE';
